import { buildComponent } from '#components'
import { z } from 'zod'
import CompleteTheLookVue from './CompleteTheLook.vue'

import './complete-the-look.css'

const CompleteTheLookVariantSchema = z.object({
  id: z.number(),
  title: z.string(),
  price: z.number(),
  compare_at_price: z.number().nullable(),
  available: z.boolean(),
  option1: z.string(),
  option2: z.string().nullable(),
  option3: z.string().nullable()
})

const CompleteTheLookPropsSchema = z.object({
  products: z.array(
    z.object({
      id: z.number(),
      handle: z.string(),
      title: z.string(),
      price: z.number(),
      compare_at_price: z.number().nullable(),
      available: z.boolean(),
      options: z.array(z.string()),
      variants: z.array(CompleteTheLookVariantSchema),
      featured_image: z.string(),
      images: z.array(z.string()),
      tags: z.array(z.string())
    })
  )
})

export type CompleteTheLookProps = z.infer<typeof CompleteTheLookPropsSchema>

export type CompleteTheLookVariant = z.infer<typeof CompleteTheLookVariantSchema>

const CompleteTheLook = buildComponent({
  name: 'complete-the-look',
  propsSchema: CompleteTheLookPropsSchema,
  vueComponent: CompleteTheLookVue
})

declare global {
  interface HTMLElementTagNameMap {
    'complete-the-look': typeof CompleteTheLook
  }
}
